import { portalPaths } from '@provision/portal-routes';
import { useCallback } from 'react';
import { Address } from 'src/graphql';
import { EntityNames } from 'src/graphql/types';
import { useNavigateRoute } from 'src/utils/routing';
import { Platform } from 'src/utils/system';
import { useCustomView } from './use-custom-view';
import { TabType, useGlobalTabs } from './use-global-tabs';

export const useOpenSite = () => {
  const { partnerPrefix, navigate } = useNavigateRoute();

  const customViewId = useCustomView(EntityNames.Site)?.customViewId;

  const { openInTab } = useGlobalTabs();

  return useCallback(
    (
      event: React.MouseEvent<HTMLElement>,
      site: Pick<Address, 'id' | 'addressId' | 'partnerId'>,
    ) => {
      if (event.shiftKey) {
        // using setTimeout to ensure the new tab opens instead of a window
        setTimeout(() => {
          window.open(
            `${partnerPrefix ? `/${partnerPrefix}` : ''}${portalPaths.site.full(site.id)}`,
            '_blank',
          );
        }, 0);
      } else if (Platform.isMacOS ? event.metaKey : event.ctrlKey) {
        openInTab({ entity: site, type: TabType.Site }, { customViewId });
      } else {
        navigate(portalPaths.site.full(site.id), { state: { customViewId } });
      }
    },
    [customViewId, navigate, openInTab, partnerPrefix],
  );
};
